import Info from "../models/user-model";
import * as Notifications from 'expo-notifications';
import * as Permissions from 'expo-permissions';
import {Platform} from 'react-native';

export const SET_DATA = 'SET_DATA';
export const UPDATE_DATA = 'UPDATE_DATA';
export const DEACTIVATE_USER = 'DEACTIVATE_USER';

export const setData = (name, emailAddress, message, emailAddressRecipient, dateLastAlive, activeUser, disclosed) => {
    return async (dispatch, getState) => {
        let pushToken
        if (Platform.OS != 'web') {
            let statusObj = await Notifications.getPermissionsAsync();
            if (statusObj.status !== 'granted') {
                statusObj = await Notifications.requestPermissionsAsync();
            }
            if (statusObj.status !== 'granted') {
                pushToken = null;
            } else {
                pushToken = (await Notifications.getExpoPushTokenAsync()).data;
            };
        } else {
            pushToken = null;
        }

        const userId = getState().auth.userId
        const token = getState().auth.token
        const response = await fetch(`https://fromhereafter.firebaseio.com/userdata/${userId}.json?auth=${token}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                name,
                emailAddress,
                message,
                emailAddressRecipient,
                dateLastAlive,
                activeUser,
                disclosed,
                pushToken
            })
        });

        if (!response.ok) {
            throw new Error('Something went wrong')
        }

        const resData = await response.json();
        
        dispatch({
            type: SET_DATA, userData: {
                id: resData.name,
                name,
                emailAddress,
                message,
                emailAddressRecipient,
                dateLastAlive,
                activeUser,
                disclosed
            }
        });
    }
};

export const updateData = (id, name, emailAddress, message, emailAddressRecipient, dateLastAlive) => {
    return async (dispatch, getState) => {
        let pushToken
        if (Platform.OS != 'web') {
            let statusObj = await Notifications.getPermissionsAsync();
            if (statusObj.status !== 'granted') {
                statusObj = await Notifications.requestPermissionsAsync();
            }
            if (statusObj.status !== 'granted') {
                pushToken = null;
            } else {
                pushToken = (await Notifications.getExpoPushTokenAsync()).data;
            };
        } else {
            pushToken = null;
        }

        const userId = getState().auth.userId
        const token = getState().auth.token
        const response = await fetch(`https://fromhereafter.firebaseio.com/userdata/${userId}/${id}.json?auth=${token}`, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                name,
                emailAddress,
                message,
                emailAddressRecipient,
                dateLastAlive,
                pushToken
            })
        });

        
        if (!response.ok) {
            throw new Error('Something went wrong')
        }

        const resData = await response.json();
        
        dispatch({
            type: UPDATE_DATA, userData: {
                id,
                name,
                emailAddress,
                message,
                emailAddressRecipient,
                dateLastAlive
            }
        });
    }
}


export const fetchData = () => {
    return async (dispatch, getState) => {
        const userId = getState().auth.userId;
        const token = getState().auth.token;
        const response = await fetch(`https://fromhereafter.firebaseio.com/userdata/${userId}.json?auth=${token}`);

        if (!response.ok) {
            throw new Error('Something went wrong')
        }


        const resData = await response.json()
        const loadedUserData = [];
        
        for (const key in resData) {
            loadedUserData.push(new Info(key, resData[key].name, resData[key].emailAddress, resData[key].message, resData[key].emailAddressRecipient, resData[key].dateLastAlive, resData[key].activeUser, resData[key].disclosed))
        }

        dispatch({
            type: SET_DATA, userData: {
                id: loadedUserData[0].id,
                name: loadedUserData[0].name,
                emailAddress: loadedUserData[0].emailaddress,
                message: loadedUserData[0].message,
                emailAddressRecipient: loadedUserData[0].emailaddressRecipient,
                dateLastAlive: loadedUserData[0].dateLastAlive,
                activeUser: loadedUserData[0].activeUser,
                disclosed: loadedUserData[0].disclosed
            }
        });
    }
};

export const deactivateUser = (activeUser) => {
    return async (dispatch, getState) => {
        const userId = getState().auth.userId
        const token = getState().auth.token
        const id = getState().userdata.userData.id
        const response = await fetch(`https://fromhereafter.firebaseio.com/userdata/${userId}/${id}.json?auth=${token}`, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                activeUser
            })
        });
        
        if (!response.ok) {
            throw new Error('Something went wrong')
        }

        
        dispatch({
            type: DEACTIVATE_USER, userData: {
                activeUser
            }
        }); 
    }
}




